module.exports = __webpack_public_path__ + "img/hand.a69b30bc.png";